angular.module('impactx.themeworld').controller('ThemeWorldInvalidProductsCtrl', [
    '$scope',
    'dataGen',
    'ThemeWorldService',
    'DialogPanelService',
    'TranslationService',
    'panelService',
    'ToastService',
    ThemeWorldInvalidProductsController]);

function ThemeWorldInvalidProductsController($scope, dataGen, ThemeWorldService, DialogPanelService, TranslationService, panelService, ToastService) {
    var self = this;

    $scope.filters = true; // just to make it not false
    if(!$scope.trns){
        $scope.trns = {};
    }
    $scope.trns.select = TranslationService.get('select');
    $scope.trns.selected = TranslationService.get('selected');

    self.searchInput = "";
    self.getProductPanelColor = panelService.getProductPanelColor;
    self.locals = DialogPanelService.readLocals();
    self.selectedRows = [];
    self.showDefaultActions = false;
    self.useMultiSelect = false;
    self.showFilters = false;

    self.itemActions = impactX.isDefined(self, 'locals.itemActions') || [];
    self.listActions = impactX.isDefined(self, 'locals.listActions') || [];

    var vcatId = impactX.isDefined(self, 'locals.vcat.id');
    
    var getData = function() {
        dataGen.getData($scope, {id: vcatId}, "/themeworld/list/invalid").then(function () {
            $scope.dynamicItems = new DynamicItems();
        });
    };
    getData();

    self.showProductDetails = function (product) {
        if ($scope.lastClickedProId == product.id) {
            $scope.lastClickedProId = undefined;
        }
        else {
            receiveProductInfo(product).then(function () {
                $scope.lastClickedProId = product.id;
            });
        }
    };

    self.checkActionCondition = function(action) {
        if (action.hasOwnProperty('condition')) {
            if (typeof action.condition === 'function') {
                return action.condition();
            }
            else {
                return action.condition;
            }
        }
        // no condition defined => always show
        return true;
    };

    self.performListAction = function(action) {
        dataGen.postAsForm({}, {vcatId: vcatId}, "/themeworld/remove/product/allInValid").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            DialogPanelService.closePanel();
        });
    };
    
    self.performItemAction = function(action, product, index) {
        event.stopPropagation();
        ThemeWorldService.removeProductsFromThemeWorld(vcatId, [product.id]).then(function () {
            $scope.data.products.splice(index, 1);
            getData();
        });
    };

    var DynamicItems = function() {
    };

    DynamicItems.prototype.getItemAtIndex = function(index) {
        if($scope.data) {
            return $scope.data.products[index]
        }
        else {
            return null;
        }
    };

    DynamicItems.prototype.getLength = function() {
        if($scope.data && $scope.data.products) {
            return $scope.data.products.length;
        }
        else {
            return 0;
        }
    };

    function receiveProductInfo(product) {
        var result = {};
        return dataGen.getData(result, {proId: product.id}, "/product/info", null, false).then(function () {
            var productInfo = impactX.isDefined(result, 'data');
            if (productInfo) {
                for (var property in productInfo) {
                    if (productInfo.hasOwnProperty(property)) {
                        product[property] = productInfo[property];
                    }
                }
            }
        });
    }
}